import React from "react";
import { Badge } from "./ui/badge";
import { MembershipPlan } from "~/lib/schemas";
import { Sparkle, Sparkles } from "lucide-react";

export const PLAN_LABELS: Record<MembershipPlan, string> = {
  [MembershipPlan.Standard]: "Standard",
  [MembershipPlan.Pro]: "Pro",
  [MembershipPlan.ProPlus]: "Pro+",
};

export const PlanBadge = ({
  membershipPlan,
  children,
  ...props
}: {
  membershipPlan: MembershipPlan;
  children?: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>) => (
  <Badge
    {...props}
    radius="rounded"
    variant={membershipPlan === MembershipPlan.Standard ? "gray" : "pro"}
  >
    {membershipPlan === MembershipPlan.Pro && <Sparkle className="size-4" />}
    {membershipPlan === MembershipPlan.ProPlus && (
      <Sparkles className="size-4" />
    )}
    {PLAN_LABELS[membershipPlan]}
    {children}
  </Badge>
);
